const scrollingText = (wrapperEl, list_width, seconds) => {
  const $tickerWrapper = wrapperEl;
  const $list = $tickerWrapper.find('div.original');

  $list.each(function () {
    const $clonedEl = this.cloneNode(true);
    $clonedEl.classList.remove('original');
    $clonedEl.classList.add('cloned');
    $tickerWrapper.append($clonedEl);
  });

  const $clonedList = $tickerWrapper.find('div.cloned');
  let listWidth =
    list_width < 1 ? $tickerWrapper.width() * -list_width : list_width;
  const totalListLength = $list.length + $clonedList.length;
  const baseTime = seconds;

  $list.each(function (i) {
    listWidth += $(this, i).outerWidth(true);
  });

  // TimelineMax
  const infinite = new TimelineMax({ repeat: -1, paused: false });
  const time = baseTime * totalListLength;
  const doubledListWidth = listWidth * 2;

  infinite
    .fromTo(
      $list,
      time,
      {
        rotation: 0.01,
        x: 0,
      },
      {
        force3D: true,
        x: -listWidth,
        ease: Linear.easeNone,
      },
      0,
    )
    .fromTo(
      $clonedList,
      time,
      {
        rotation: 0.01,
        x: 0,
      },
      {
        force3D: true,
        x: -listWidth,
        ease: Linear.easeNone,
      },
      0,
    )
    .set($list, {
      force3D: true,
      rotation: 0.01,
      x: listWidth,
    })
    .to(
      $clonedList,
      time,
      {
        force3D: true,
        rotation: 0.01,
        x: -doubledListWidth,
        ease: Linear.easeNone,
      },
      time,
    )
    .to(
      $list,
      time,
      {
        force3D: true,
        rotation: 0.01,
        x: 0,
        ease: Linear.easeNone,
      },
      time,
    )
    .progress(1)
    .progress(0)
    .play();

  // Pause/Play
  $tickerWrapper
    .on('mouseenter', function () {
      infinite.pause();
    })
    .on('mouseleave', function () {
      infinite.play();
    });
};

export default scrollingText;
